import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200/80 bg-white/90 py-6 text-sm text-textMuted">
      <div className="section-wrap flex flex-col items-center justify-between gap-4 md:flex-row">
        <p className="font-medium text-secondary">&copy; {currentYear} DeCipher. All rights reserved.</p>
        <div className="flex flex-wrap items-center justify-center gap-5">
          <a 
            href="mailto:deciphertextco@gmail.com"
            className="transition hover:text-primary"
          >
            Contact Us
          </a>
          <button
            onClick={() => navigate("/terms")}
            className="transition hover:text-primary"
          >
            Terms & Conditions
          </button>
          <button
            onClick={() => navigate("/privacy")}
            className="transition hover:text-primary"
          >
            Privacy Policy
          </button>
        </div>
      </div>
    </footer>
  );
}